<!-- =========================================================================================
    File Name: CardBasic.vue
    Description: Basic Cards
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
    <div id="demo-basic-card">
        <!-- {{ invoices }} -->
        <div class="vx-row">
            <div class="vx-col w-full">
                <vs-button type="gradient" class="w-1/3 mb-4" color="#7367F0" gradient-color-secondary="#CE9FFC"
                    @click="popupAddPacote = true">Efectuar pagamento</vs-button>



                <vs-popup class="holamundo" title="Efectuar pagamento" :active.sync="popupAddPacote">
                    <div class="vx-row">
                        <div class="vx-col w-full mb-2">
                            <label class="mt-8 text-bold" for="">Selecione o pacote </label>

                        <v-select
                 label="name"
                  :options="pacotes"
                  v-model="selectedPackage"
                name="name"
              />
                        </div>
                        <div class="vx-col w-full mb-2">
                            <label class="mt-8" for="">Periodo</label>
                            <div class="mt-2 ">
        <vs-radio v-model="frequency" vs-value="Mensal" class="mr-4">Mensal</vs-radio>
        <vs-radio v-model="frequency" vs-value="Trimestral" class="mr-4">Trimestral</vs-radio>
        <vs-radio v-model="frequency" vs-value="Semestral" class="mr-4">Semestral</vs-radio>
        <vs-radio v-model="frequency" vs-value="Anual" class="mr-4">Anual</vs-radio>
      </div>
                        </div>
                        <div class="vx-col w-full mb-2">
                            <label class="mt-8" for="">Metodo de pagamento</label>
                            <div  class="mt-2 ">
                                <img src="./mpesa.png" alt="" height="80">
        <vs-radio v-model="type" vs-value="Mpesa" class="ml-2 mr-4">M-PESA</vs-radio>
        <img src="./emola.png" alt="" height="80">
        <vs-radio v-model="type" vs-value="E-Mola" class="ml-2 mr-4">E-MOLA</vs-radio>
        <img src="./deposito.png" alt="" height="80">
        <vs-radio v-model="type" vs-value="Deposito" class="ml-2 mr-4">Deposito</vs-radio>
      </div>
                        </div>
                        <div class="vx-col w-full mb-2" v-if="type=='Mpesa'|| type=='E-Mola'">
                            <label class="mt-8" for="">Numero de celular</label>
                            <div class="mt-2">
                                <vx-input-group class="mb-base">
            
            <vs-input  class="w-full " type="number" v-model="phone"/>
<template slot="prepend">
  <div class="prepend-text bg-primary">
<span>+258</span>
</div>
</template>
</vx-input-group>
      </div>
                        </div>
                        

                        <div class="vx-col w-full mb-2">
                            <div class="flex flex-wrap items-center flex-start">
                                <vs-button class="ml-auto mt-2" :disabled="frequency=='' || type=='' || selectedPackage==''" @click="efectuarPagamento">Pagar</vs-button>
                                <!-- <vs-button class="ml-4 mt-2" type="border" color="warning">Cancelar</vs-button> -->
                            </div>

                        </div>
                    </div>
                </vs-popup>

                <vs-popup class="holamundo" title="Actualizar Pacote" :active.sync="popupOpenEditPacote">
                    <div class="vx-row">
                        <div class="vx-col w-full mb-2">
                            <label class="mt-8" for="">Nome</label>
                            <vs-input class="w-full mt-2 mb-5" type="text" v-model="nome" />
                        </div>
                        <div class="vx-col w-full mb-2">
                            <label class="mt-8" for="">Preço</label>
                            <vs-input class="w-full mt-2 mb-5" type="number" v-model="preco"/>
                        </div>
                        <div class="vx-col w-full mb-2">
                            <label class="mt-8" for="">Descrição</label>
                            <vs-input class="w-full mt-2 mb-5" type="text" v-model="descricao"/>
                        </div>

                        <div class="vx-col w-full mb-2">
                            <div class="flex flex-wrap items-center flex-start">
                                <vs-button class="ml-auto mt-2" :disabled="nome=='' || preco=='' || descricao==''" @click="savePackage">Paga</vs-button>
                                <!-- <vs-button class="ml-4 mt-2" type="border" color="warning">Cancelar</vs-button> -->
                            </div>

                        </div>
                    </div>
                </vs-popup>
              
               
            </div>

          
            <div class="vx-col w-full ">
                <vx-card>
                    <vs-table :data="invoices">



<template slot="thead">
    <vs-th sort-key="name">Pacote</vs-th>
    <vs-th sort-key="name">Periodo</vs-th>
    <vs-th sort-key="name">Data de pagamento</vs-th>
    <vs-th sort-key="name">Válido até</vs-th>

  <vs-th sort-key="name">Metodo de pagamento</vs-th>
  <vs-th sort-key="name">Estado</vs-th>
  <!-- <vs-th></vs-th> -->
</template>

<template slot-scope="{data}">
  <vs-tr v-for="invoice in invoices" :key="id">
    <vs-td >
        {{ invoice.package_name }}
    </vs-td>
    <vs-td >
        {{ invoice.frequency }}
    </vs-td>
    <vs-td >
        {{ invoice.created_at }}
    </vs-td>
    <vs-td >
        {{ invoice.expiryDate }}
    </vs-td>

    
    <vs-td >
        {{ invoice.type }}
    </vs-td>
   
    <vs-td >
        <vs-chip v-if="invoice.status=='Pago'" class="font-bold">
                        <div class="h-2 w-2 rounded-full mr-1" :class="'bg-success'"></div>
                        <span>{{ invoice.status }}</span>
                    </vs-chip>
                    <vs-chip v-else class="font-bold">
                        <div class="h-2 w-2 rounded-full mr-1" :class="'bg-warning'"></div>
                        <span>{{ invoice.status }}</span>
                    </vs-chip>
    </vs-td>
    <!-- <vs-td class="whitespace-no-wrap" >

      <vs-button color="danger" size="small" hover:text-danger type="border" icon-pack="feather" icon="icon-cancel"
      >Cancelar</vs-button>

    </vs-td> -->

  </vs-tr>
</template>
</vs-table >
<div  style="height: 50px;" id="div-with-loading" class="vs-con-loading__container"></div>
                </vx-card>
            </div>
          











            <!-- CONTENT CARD - ICONS -->


        </div>


    </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { videoPlayer } from 'vue-video-player'
import VxTimeline from "@/components/timeline/VxTimeline.vue"
import 'video.js/dist/video-js.css'
import http from '../../../../http-common'
import vSelect from 'vue-select'


export default {
    components:{
        vSelect
    },
    data() {
        return {
            popupAddPacote: false,
            nome:"",
            preco:"",
            descricao:"",
            pacotes:[],
            popupAddModulo:false,
            popupOpenEditPacote:false,
            popupModulo:false,

            nomeModulo:"",
            descricaoModulo:"",
            modulos:[],
            pacoteSelected:[],
            selectedModule:[],
            selectedPackage:[],
            frequency:"",
            type:"",
            phone:"",
            invoices:"",
            company_id:"",
        }
    },

    mounted() {
        this.getModules();
        this.getPackege(),
        this.getCurrentUser(),
        this.getInvoices()
      
    },
    created() {

    },
    methods: {
       async efectuarPagamento() {
      this.$vs.loading()

      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };

      const data = {
        package_id: this.selectedPackage.id,
        type: this.type,
        frequency: this.frequency,
        phone:'258'+this.phone,
        


      };

      this.$validator.validateAll();
      await http
        .post("/admin/invoices", data, config)
        .then((success) => {
          success;
          this.popupAddPacote = false,
            this.nome = "",
            this.descricao = "",
            this.preco = "",
          

            this.getInvoices(),
            this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: "Salvo com sucesso",
            color: "success",
            position: "top-right",
          })
        })
        .catch((error) => {
          error;
          this.$vs.loading.close();
          if (error.response.status == 401) {
            this.$router.push('/').catch(() => { })
          }
          if (error.response.status == 422) {
            this.err = error.response.data
            console.log(this.err)
            this.$vs.notify({
              title: "Erro",
              text: this.err,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "warning",
              position: "top-right",
            })
          } else {
            this.$vs.notify({
              title: "Erro",
              text: "Aconteceu algum erro",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-right",
            })
          }

        });
    },
    getPackege() {
    //   this.$vs.loading({
    //     container: '#div-with-loading',
    //     scale: 1.0,
    //     type: 'sound'
    //   })
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
       

      };

      http
        .get("/admin/packages", config)
        .then((result) => {
        //   this.$vs.loading.close('#div-with-loading > .con-vs-loading')
          this.pacotes = result.data
        
          // alert("2")
        })
        .catch((error) => {
          error;
          this.dataNotLoading = true
          if (error.response.status == 401) {
            this.$router.push('/').catch(() => { })
          }

        });
    },

    getCurrentUser(){
      let authUser = localStorage.getItem('user');
      var authUserObject = JSON.parse(authUser);
       this.company_id = authUserObject.company_id;
     
    },
    getInvoices() {
      
      this.$vs.loading({
        container: '#div-with-loading',
        scale: 1.0,
        type: 'sound'
      })
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
       
        params:{
            company_id:this.company_id
        }

      };

      http
        .get("/admin/invoices", config)
        .then((result) => {
          this.$vs.loading.close('#div-with-loading > .con-vs-loading')
          this.invoices = result.data.data.filter(objeto => objeto.status == "Pendente")
        
          // alert("2")
        })
        .catch((error) => {
          error;
          this.dataNotLoading = true
          if (error.response.status == 401) {
            this.$router.push('/').catch(() => { })
          }

        });
    },
    getModules() {
    //   this.$vs.loading({
    //     container: '#div-with-loading',
    //     scale: 1.0,
    //     type: 'sound'
    //   })
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
       

      };

      http
        .get("/admin/modules", config)
        .then((result) => {
        //   this.$vs.loading.close('#div-with-loading > .con-vs-loading')
          this.modulos = result.data
        
          // alert("2")
        })
        .catch((error) => {
          error;
          this.dataNotLoading = true
          if (error.response.status == 401) {
            this.$router.push('/').catch(() => { })
          }

        });
    },

 
    },
}
</script>

<style lang="scss">
#demo-basic-card {
    .overlay-card {
        .vx-card__collapsible-content {
            max-height: 485px;
        }
    }

    .chat-card-log {
        height: 360px;

        .chat-sent-msg {
            background-color: #f2f4f7 !important;
        }
    }

    .card-video {
        .video-js {
            height: 370px;
        }
    }
}</style>
